import React from 'react';

/**
 * Jellyfish — 真实动态水母 + Apple 级漂浮动画
 *
 * 设计：
 *   - 主图：深海水母 webp（6.77MB，自带动画帧）
 *   - 漂浮：垂直 + 水平双轴正弦波动
 *   - 旋转：微幅摆动模拟水中阻力
 *   - 光晕：呼吸式辉光强度变化
 */
const Jellyfish = ({
  size = 100,
  delay = 0,
  duration = 10,
  drift = 8,
  opacity = 0.6,
}) => {
  const uid = `jfw-${Math.random().toString(36).slice(2, 7)}`;

  return (
    <div
      style={{
        position: 'relative',
        width: size,
        height: size,
        animation: `jFloat${uid} ${duration}s ease-in-out ${delay}s infinite`,
        willChange: 'transform',
      }}
    >
      <style>{`
        @keyframes jFloat${uid} {
          0%, 100% { transform: translate(0, 0) rotate(0deg); }
          25%      { transform: translate(${drift}px, -8px) rotate(1.5deg); }
          50%      { transform: translate(${drift * 0.5}px, 4px) rotate(-1deg); }
          75%      { transform: translate(-${drift}px, -5px) rotate(0.8deg); }
        }
        .jGlow${uid} {
          animation: jGlow${uid} ${duration * 0.8}s ease-in-out ${delay}s infinite;
        }
        @keyframes jGlow${uid} {
          0%, 100% { filter: drop-shadow(0 0 ${size/5}px rgba(100, 200, 255, 0.35)) drop-shadow(0 0 ${size/3}px rgba(60, 140, 220, 0.15)); }
          50%      { filter: drop-shadow(0 0 ${size/3.5}px rgba(100, 200, 255, 0.5)) drop-shadow(0 0 ${size/2}px rgba(60, 140, 220, 0.25)); }
        }
      `}</style>
      <img
        src="/jellyfish-animated.webp"
        alt=""
        className={`jGlow${uid} pointer-events-none select-none`}
        style={{
          width: '100%',
          height: '100%',
          opacity,
          objectFit: 'contain',
          transformOrigin: '50% 30%',
        }}
        draggable={false}
      />
    </div>
  );
};

export default Jellyfish;
